/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmAddressDetailInfo } from '../models/EvmAddressDetailInfo';
import type { EvmAddressListInfo } from '../models/EvmAddressListInfo';
import type { EvmContractCodeInfo } from '../models/EvmContractCodeInfo';
import type { EvmDeployContractListInfo } from '../models/EvmDeployContractListInfo';
import type { EvmInternalTrxListInfo } from '../models/EvmInternalTrxListInfo';
import type { EvmTokenListInfo } from '../models/EvmTokenListInfo';
import type { EvmTrxListInfo } from '../models/EvmTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmAddressControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmTokenListInfo OK
     * @throws ApiError
     */
    public getEvmTokenTransactionListByAddress({
        tokenType,
        address,
        page = 1,
        size = 25,
    }: {
        tokenType: 'NA' | 'CA' | 'ERC20' | 'ERC721' | 'ERC1155',
        address: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/address/transaction/token/list',
            query: {
                'tokenType': tokenType,
                'address': address,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenListInfo OK
     * @throws ApiError
     */
    public getEvmTokenTransactionListByAddress1({
        tokenType,
        address,
        page = 1,
        size = 25,
    }: {
        tokenType: 'NA' | 'CA' | 'ERC20' | 'ERC721' | 'ERC1155',
        address: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/address/transaction/token/list',
            query: {
                'tokenType': tokenType,
                'address': address,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTrxListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionListByAddress({
        address,
        page = 1,
        size = 25,
    }: {
        address: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/address/transaction/list',
            query: {
                'address': address,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTrxListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionListByAddress1({
        address,
        page = 1,
        size = 25,
    }: {
        address: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/address/transaction/list',
            query: {
                'address': address,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmInternalTrxListInfo OK
     * @throws ApiError
     */
    public getEvmInternalTransactionListByAddress({
        address,
        page = 1,
        size = 25,
    }: {
        address: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmInternalTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/address/transaction/internal/list',
            query: {
                'address': address,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmInternalTrxListInfo OK
     * @throws ApiError
     */
    public getEvmInternalTransactionListByAddress1({
        address,
        page = 1,
        size = 25,
    }: {
        address: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmInternalTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/address/transaction/internal/list',
            query: {
                'address': address,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmAddressListInfo OK
     * @throws ApiError
     */
    public getEvmAddressList({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmAddressListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/address/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmAddressListInfo OK
     * @throws ApiError
     */
    public getEvmAddressList1({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmAddressListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/address/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmDeployContractListInfo OK
     * @throws ApiError
     */
    public getEvmContractCodeList({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmDeployContractListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/address/contract/code/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmDeployContractListInfo OK
     * @throws ApiError
     */
    public getEvmContractCodeList1({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmDeployContractListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/address/contract/code/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmContractCodeInfo OK
     * @throws ApiError
     */
    public getEvmContractCode({
        address,
    }: {
        address: string,
    }): CancelablePromise<EvmContractCodeInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/address/contract/code',
            query: {
                'address': address,
            },
        });
    }

    /**
     * @returns EvmContractCodeInfo OK
     * @throws ApiError
     */
    public getEvmContractCode1({
        address,
    }: {
        address: string,
    }): CancelablePromise<EvmContractCodeInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/address/contract/code',
            query: {
                'address': address,
            },
        });
    }

    /**
     * @returns EvmAddressDetailInfo OK
     * @throws ApiError
     */
    public getEvmAddressDetail({
        address,
    }: {
        address: string,
    }): CancelablePromise<EvmAddressDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/address',
            query: {
                'address': address,
            },
        });
    }

    /**
     * @returns EvmAddressDetailInfo OK
     * @throws ApiError
     */
    public getEvmAddressDetail1({
        address,
    }: {
        address: string,
    }): CancelablePromise<EvmAddressDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/address',
            query: {
                'address': address,
            },
        });
    }

}
